import template from './organizationGroupsAndBranchesList.template.html';
import templateAccountEdit from './organizationAccountEdit.template.html';

export default {
  template,
  bindings: {
    groupsAndBranches: '<',
    accounts: '=',
    onClick: '&',
    onMove: '&',
    onDelete: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $mdDialog,
      $mdMedia,
      $timeout,
      $filter,
      uiService,
      jsonFactory,
      helperService,
      listService,
      accountService,
      accountsService,
      lendersService,
      lodgementsService,
      priceFinderService,
      Accreditation,
      LenderAccreditation,
      GatewayAccreditation,
      PersonalTitle,
      authenticationService,
      GOOGLEMAPS,
      INSTANCE
    ) {
      'ngInject';

      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.INSTANCE = INSTANCE;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.CurrentAccount = null;
      ctrl.availableAccounts = [];
      ctrl.currentOrganization = null;
      ctrl.currentOrganizationBranch = null;
      ctrl.showingBranches = false;
      ctrl.showingAccounts = false;
      ctrl.showingAccountsInBranch = false;
      ctrl.list = listService;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.isOwner = authenticationService.isOwner();
      this.resetShown = () => {
        ctrl.showingBranches = false;
        ctrl.showingAccounts = false;
      };
      this.showBranches = (organization) => {
        const wasShown = ctrl.showingBranches;
        this.resetShown();
        if (wasShown && ctrl.currentOrganization?.id === organization?.id) {
          ctrl.showingBranches = false;
          ctrl.currentOrganization = null;
        } else {
          ctrl.showingBranches = true;
          ctrl.currentOrganization = organization;
        }
      };
      this.showAccounts = (organization) => {
        const wasShown = ctrl.showingAccounts;
        this.resetShown();
        this.getAccounts(organization);
        if (wasShown && ctrl.currentOrganization?.id === organization?.id) {
          ctrl.showingAccounts = false;
          ctrl.currentOrganization = null;
        } else {
          ctrl.showingAccounts = true;
          ctrl.currentOrganization = organization;
        }
      };
      this.showAccountsInBranch = (organization) => {
        const wasShown = ctrl.showingAccountsInBranch;
        this.getAccounts(organization);
        if (wasShown && ctrl.currentOrganizationBranch?.id === organization?.id) {
          ctrl.showingAccountsInBranch = false;
          ctrl.currentOrganizationBranch = null;
        } else {
          ctrl.showingAccountsInBranch = true;
          ctrl.currentOrganizationBranch = organization;
        }
      };
      this.hasAccounts = (organization) =>
        this.getAccountsForOrganization(organization)?.accounts?.length;
      this.getAccountsList = (organization) =>
        this.getAccountsForOrganization(organization)?.accounts || [];
      this.getAccountsForOrganization = (organization) =>
        _.find(
          ctrl.availableAccounts,
          (accounts) => accounts.idOrganization === organization.id
        );
      this.getManagingAgents = (organization) =>
        _.filter(ctrl.accounts, (a) => organization.idManagers.indexOf(a.id) > -1);
      ctrl.getBranches = (group) =>
        _.filter(ctrl.groupsAndBranches, (o) => o.isBranch() && o.idParent === group.id);

      this.initialize = () => {
        ctrl.CurrentAccount = $rootScope.CurrentAccount;
        ctrl.list.setData(_.filter(ctrl.groupsAndBranches, (o) => o.isGroup()));
        ctrl.onReady({ list: ctrl.list });
      };
      this.getAccounts = (organization) => {
        if (!this.getAccountsForOrganization(organization)?.accounts?.length) {
          accountsService
            .getInOrganization({ idOrganization: organization.id })
            .then((accounts) => {
              ctrl.availableAccounts.push({
                idOrganization: organization.id,
                accounts
              });
            });
        }
      };
      this.click = ($event, data) => {
        ctrl.onClick({ event: $event, data });
      };
      this.move = ($event, data) => {
        ctrl.onMove({ event: $event, data });
      };
      this.delete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };
      this.editAccount = ($event, organization, account) => {
        $event.stopPropagation();
        $mdDialog.show({
          template: templateAccountEdit,
          targetEvent: $event,
          locals: {},
          controllerAs: '$ctrl',
          controller() {
            const self = this;
            self.countries = [];
            self.timeZones = [];
            self.availableLenders = [];
            self.availableGateways = lodgementsService.getGateways();
            self.availablePersonalTitles = PersonalTitle.available();
            self.activeSection = 0;
            self.googleAutocompleteOptions = {
              componentRestrictions: GOOGLEMAPS.restrictToCountries
            };
            self.organization = organization;
            self.account = account;
            self.hasLoanQEnabled = $rootScope.hasLoanQEnabled();
            self.loanqAddress = 'https://www.loanq.com.au';
            self.loanqOrganization = organization.externalReferenceId;
            self.isAliEnabled = $rootScope.hasAliEnabled();
            self.hasPepperResolveEnabled = $rootScope.hasPepperResolveEnabled();
            self.equifaxPassword2 =
              self.account &&
              self.account.integrations &&
              self.account.integrations.equifax &&
              self.account.integrations.equifax.password;
            self.isAstuteOrg = $rootScope.isAstuteOrg();
            self.showRpData = false;
            self.showPepperResolve = false;
            self.phoneValidationMessage_mobile = '';
            self.phoneValidationMessage_fixed = '';
            self.filteredLenderCommissions = [];
            self.isApp = $rootScope.isApp();
            self.isDev = $rootScope.isDev();
            self.isChf = $rootScope.isChf();

            $q.all([
              jsonFactory.getCountries(),
              lendersService.getAvailable({
                cca2: [helperService.getOrganizationCountry().cca2]
              }),
              accountService.readAccount({
                id: self.account.id,
                idCurrentOrganization: self.organization.id
              })
            ]).then((data) => {
              const countries = data[0];
              self.countries = countries;
              self.timeZones = moment.tz.names();

              self.filteredLenderCommissions = _.filter(
                $rootScope.CurrentOrganization.enterprise.lenderCommissions,
                (lc) =>
                  lc.upfront !== null &&
                  lc.upfront !== undefined &&
                  lc.upfront >= 0 &&
                  lc.trail !== null &&
                  lc.trail !== undefined &&
                  lc.trail >= 0
              );
              const availableLenderCommissions = _.map(self.filteredLenderCommissions, 'id');
              self.availableLenders = _.chain(data[1])
                .filter((lender) => availableLenderCommissions.indexOf(lender.id) > -1)
                .sortNatural('name')
                .sortNatural('group')
                .value();

              const accountData = data[2];
              self.account = accountData;
              self.account.isBroker =
                self.organization.idBrokers.indexOf(self.account.id) > -1 ||
                self.organization.idOwner === self.account.id;

              self.saveAccount = (accData) => {
                if (accData?.id) {
                  if (!_.isEmpty(accData?.user)) {
                    self.account.user = accData.user;
                  }
                  if (!_.isEmpty(accData?.exchange)) {
                    self.account.exchange = accData.exchange;
                  }
                  if (accData?.accreditations) {
                    self.account.accreditations = accData.accreditations;
                  }
                  if (accData?.lenderAccreditations) {
                    self.account.lenderAccreditations = accData.lenderAccreditations;
                  }
                  if (accData?.gatewayAccreditations) {
                    self.account.gatewayAccreditations = accData.gatewayAccreditations;
                  }
                  if (!_.isEmpty(accData?.userInterface)) {
                    self.account.userInterface = accData.userInterface;
                  }
                  if (!_.isEmpty(accData?.userInterface)) {
                    self.account.userInterface = accData.userInterface;
                  }
                  if (!_.isEmpty(accData?.notifications)) {
                    self.account.notifications = accData.notifications;
                  }
                  if (!_.isEmpty(accData?.integrations) && accData?.integration) {
                    self.account.integrations[accData.integration] =
                      accData.integrations[accData.integration];
                  }
                }
              };

              self.isReady = true;
            });

            this.toggleSection = (section) => {
              self.activeSection = section;
            };

            this.confirm = () => {
              self.account.idCurrentOrganization = self.organization.id;

              accountService.updateAccount(self.account).then((result) => {
                if (result.status) {
                  uiService.toast({
                    text: {
                      p1: 'Account',
                      p2: 'modified',
                      p3: 'successfully'
                    }
                  });
                  $mdDialog.hide();
                }
              });
            };

            this.cancel = () => {
              $mdDialog.cancel();
            };
          }
        });
      };

      this.$onInit = () => {
        ctrl.initialize();
      };

      this.$onChanges = (changes) => {
        if (changes.groupsAndBranches && changes.groupsAndBranches.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
